import { Actions, thunk } from 'easy-peasy';
import formatTrigger from '~/utils/formatTrigger';
import api from '~/services/api';
import { IThunkCreateTrigger, IClientDetailsStore, IClientDetailsActions } from '../types';

const onCreateTrigger: IThunkCreateTrigger = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    const { requestInfo, requestPayload } = payload;

    const clientTrigger = await api.clientDetails
      .createClientTrigger(requestInfo, requestPayload)
      .then(r => r.data);

    const triggers = [formatTrigger(clientTrigger), ...localState.triggers];

    setClientDetails({ triggers });
  },
);

export default onCreateTrigger;
